import { useState, useEffect } from "react";
import SortableTree, { toggleExpandedForAll, removeNodeAtPath, addNodeUnderParent, getFlatDataFromTree, getTreeFromFlatData, changeNodeAtPath } from "@nosferatu500/react-sortable-tree";
// import FileExplorerTheme from "react-sortable-tree-theme-full-node-drag";
// import FileExplorerTheme from "react-sortable-tree-theme-minimal";
import { BsArrowsAngleExpand, BsArrowsAngleContract } from "react-icons/bs";
import { HiOutlineArrowRight, HiOutlineSearch, HiOutlineArrowLeft, HiDotsHorizontal, HiOutlineDuplicate, HiOutlineTrash, HiOutlinePrinter } from "react-icons/hi";
import { BiExport } from "react-icons/bi";
import { FiSave, FiEdit3 } from "react-icons/fi";
import SortModal from "../SortModal";
import { Button, TextInput, Tooltip } from "flowbite-react"
import { useDispatch, useSelector } from 'react-redux'
import MenuProductItem from "../MenuProductItem";
import styled from 'styled-components';
import CreateGroupModal from "../CreateGroupModal";
import AddProductsModal from "../AddProductsModal";
import "@nosferatu500/react-sortable-tree/style.css";
import swal from 'sweetalert2';
import { openSnackBar } from '../../../redux/snackBarReducer';
import { saveSortableTree, downloadImage } from '../../../redux/menuReducer';
import { setNoSavedEditedWineMenuPage } from '../../../redux/globalReducer';
import { parse, stringify } from 'flatted';
import flatten from 'tree-flatten'
import flatToTree from "flat-to-tree";
import recursively from 'recursively';
import _ from "lodash";
import groupArray from 'group-array';
import arrSort from 'arr-sort';
import downloadCsv from 'download-csv';
import { useBeforeunload } from 'react-beforeunload';
import { useTranslation } from "react-i18next";
import utf8 from 'utf8';
import {parse as tab_parse, stringify as tab_stringify} from 'tab-delimited';
import FileSaver from 'file-saver';
import {Buffer} from 'buffer/'

import { API_BASE } from "../../../config/constants"
import './sortable.scss';
import Loading from "../../Global/Loading";

export const SortableStyle = styled.div`
.text-base, .font-semibold{
    white-space: normal;
}
.rst__virtualScrollOverride{
    height: 1000px !important;
}
`

const maxDepth = 9;
var temper = [];
var group, group_order, ungroup, ungroup_order, ungroup_final, group_final, total_group, total_group_order, total_group_final;

function Sortable(props) {
    const { t } = useTranslation();
    const { authState, globalState, menuState } = useSelector((state) => state);
    const { userInfo } = authState;

    const { downloadImageState, saveSortableTreeState } = menuState;
    const [searchString, setSearchString] = useState("");
    const [searchFocusIndex, setSearchFocusIndex] = useState(0);
    const [searchFoundCount, setSearchFoundCount] = useState(null);
    const [treeData, setTreeData] = useState(props.tree ? parse(props.tree) : []);
    const [sortData, setSortData] = useState([]);
    const [changedMenuProducts, setChangedMenuProducts] = useState([]); //when user edit the menu, duplicate and add products changed, save product list
    const [uniqueIndex, setUniqueIndex] = useState(props.tree ? props?.products[props?.products?.length - 1].index + 1 : props?.products?.length); // for identify the product
    const [isSaveDisable, setIsSaveDisable] = useState(true);

    // var products = currentWineMenu?.products;
    const { products, menu_id, menu_name } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        setMenuSaveDisable(true);
        if (props.tree) {
            const getKey = node => node._id;
            const getParentKey = node => node.parent_id;
            const rootKey = null;

            const newTreeData = parse(props.tree);

            const flatData = newTreeData.map(node => ({
                ...node,
                _id: node.treeIndex,
                parent_id: node.path.length > 1 ? node.path[node.path.length - 2] : null,
            }));

            console.log("flatData:", flatData);

            const data = getTreeFromFlatData({
                flatData,
                getKey,
                getParentKey,
                rootKey,
            });

            let tmpProducts = [];//for add index to changedMenuProducts
            let addNode = [];
            let productss = [];

            products.map((data) => {
                if (Number.isInteger(data.index)) {
                    tmpProducts = [...tmpProducts, { ...data }];
                } else {
                    productss = [...productss, { ...data, price: [] }]
                }
            })

            productss.map((data, index) => {
                productss[index] = { ...productss[index], index: tmpProducts[tmpProducts.length - 1].index + 1 + index };
                addNode = [...addNode, {
                    title: data.product.search_field,
                    subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={index} data={data} menu_id={menu_id} index={tmpProducts[tmpProducts.length - 1].index + 1 + index} isNew={true} />,
                    index: tmpProducts[tmpProducts.length - 1].index + 1 + index
                }]
            })

            tmpProducts = [...tmpProducts, ...productss];
            temper = tmpProducts; //global products
            setUniqueIndex(tmpProducts[tmpProducts.length - 1].index + 1 + productss.length);
            setChangedMenuProducts([...tmpProducts]);

            console.log("data:", data)
            let treeStructure = [];
            const customize = (item, index) => {
                // console.log("item", index, item);
                const pos = tmpProducts.findIndex(x => x.index === item.node.index);
                if (item.node.subtitle) {//if exist the subtitle this is product
                    if(pos != -1){
                        treeStructure = [...treeStructure, {
                            title: item.node.title,
                            subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={item.node.index} data={tmpProducts[pos]} menu_id={item.node.subtitle.props.menu_id} index={item.node.index} />,
                            id: item._id,
                            parentId: item.parent_id,
                            index: item.node.index
                        }]
                    }
                } else {// else this isnt product, this is node
                    treeStructure = [...treeStructure, {
                        title: item.node.title,
                        parentId: item.parent_id,
                        id: item._id,
                    }]
                }
            }
            recursively(data, customize, 'children');

            let existTreeData = flatToTree(treeStructure);

            setTreeData([...addNode, ...existTreeData]);

            console.log("changedPRoducts:", changedMenuProducts)
            console.log("treeStruc", existTreeData);
            console.log("unique", tmpProducts[tmpProducts.length - 1].index + 1 + productss.length)

            if(productss.length > 0){
                const getNodeKey = ({ treeIndex }) => treeIndex;
                let extendedTreeData = toggleExpandedForAll({ treeData: [...addNode, ...existTreeData], expanded: true });
                const flatteningNestedArray = getFlatDataFromTree({ treeData: extendedTreeData, getNodeKey });
    
                console.log("flatte:", flatteningNestedArray);
    
                let saveProducts = [];
                tmpProducts.map((data) => {
                    saveProducts = [...saveProducts, { product: data.product._id, price: data.price, product_type: data.product_type._id, category: data.category, sub_category: data.sub_category, index: data.index }]
                })
    
                dispatch(saveSortableTree({ tree: stringify(flatteningNestedArray), menu_id: menu_id, user_id: userInfo.id, products: JSON.stringify(saveProducts) }))
            }
        } else {
            let tmpProducts = [];//for add index to changedMenuProducts
            products?.length > 0 && products.map((data, index) => {
                tmpProducts = [...tmpProducts, { ...data, index: index }];
            })

            let customized_products = customizeProducts(tmpProducts);    //customize the products list for group add some field and change

            // customizeGroup(data);   // get the checked group and unchecked group also total group for sort and make the node
            group = ["product_type.sort_id", "product.product_sub_category.sort_id", "product.wine_color.sort_id"];
            group_order = ["no", "no", "no"];
            ungroup = ['product.country.name.'+globalState.language, 'product.region.name.'+globalState.language, 'product.producer.name', 'product.product_name']; //"product.country.sort_id", "product.region.sort_id", 
            // ungroup = ["product.producer_sort"]; //"product.country.sort_id", "product.region.sort_id", 
            ungroup_order = [true, true, true, true]; //, true, true
            total_group = ["product_type._id", "product.product_sub_category.index", "wine_color.sort_id",  "product.producer_sort"];//"product.country.sort_id", "product.region.sort_id",
            total_group_order = [true, true, true, true, true, true, true]; //, true, true

            ungroup_final = []; //initialize
            group_final = [];   //initialize
            total_group_final = []; //initialize

            if (total_group.length > 0) {   //customize for tatal sort products
                total_group.map((data, index) => {
                    total_group_final = [...total_group_final, { attr: data, asc: total_group_order[index] }]
                })
            }

            customized_products = arrSort(customized_products, [...total_group_final]);     //total sort products

            if (group.length === 0) {    //when not checked the group
                let result = [];

                customized_products.map((data, index) => {
                    result = [...result, {
                        title: data.product.search_field,
                        subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={data.index} data={data} menu_id={menu_id} index={data.index} />,
                        index: data.index
                    }]
                });

                setTreeData(result);
            } else {
                if (ungroup.length > 0) {   //customize for ungroup sort products
                    ungroup.map((data, index) => {
                        ungroup_final = [...ungroup_final, { attr: data, asc: ungroup_order[index] }]
                    })
                }
                if (group.length > 0) { //customize for group sort products
                    group_order.map((data, index) => {
                        group_final = [...group_final, { attr: 'title', asc: data }]
                    })
                }


                let grouped_product = group.length > 0 ? groupArray(customized_products, [...group]) : customized_products; //group by the products

                let customizedTreeData = getNodes(grouped_product); //flat JSON file to tree data with children

                const sortGroup = (item, index) => {    //when title with & so mean sort by id, remove the unnecessary field
                    let pos = item.title.indexOf('&');
                    if (pos !== -1) {
                        item.title = item.title.substring(pos + 1);
                    }
                }
                recursively(customizedTreeData, sortGroup, 'children'); //customize the data to show the react-sortable-tree

                setTreeData(customizedTreeData);
            }

            temper = tmpProducts;
            setChangedMenuProducts([...tmpProducts]);
            setUniqueIndex(tmpProducts.length); //for indentify the products
        }
    }, [props.tree])

    /////////////////for leave site action detect////////////////////////////////////////
    // useEffect(() => {
    //     // the handler for actually showing the prompt
    //     // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
    //     const handler = (event) => {
    //         event.preventDefault();
    //         event.returnValue = "";
    //     };

    //     // if the form is NOT unchanged, then set the onbeforeunload
    //     if (isSaveDisable === false) {
    //         window.addEventListener("beforeunload", handler);
    //         // clean it up, if the dirty state changes
    //         return () => {
    //             window.removeEventListener("beforeunload", handler);
    //         };
    //     }
    //     // since this is not dirty, don't do anything
    //     return () => { };
    // }, [isSaveDisable]);
    useBeforeunload((event) => {
        if (isSaveDisable === false) {
            event.preventDefault();
        }
    });
    /////////////////for leave site action detect////////////////////////////////////////

    const handleTreeOnChange = (treeData) => {
        setTreeData(treeData);
        setMenuSaveDisable(false);
    };

    const changePriceOfProduct = (index, data) => {
        const pos = temper.findIndex(x => x.index === index);
        temper[pos].price = [...data]
        setChangedMenuProducts([...temper]);
        setMenuSaveDisable(false);
    }

    ////////sortable tree search begin////////////////////////////
    const handleSearchOnChange = (e) => {
        setSearchString(e.target.value);
    };

    const customSearchMethod = ({ node, searchQuery }) =>
        searchQuery &&
        node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;

    const selectPrevMatch = () => {
        setSearchFocusIndex(searchFocusIndex !== null
            ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
            : searchFoundCount - 1);
    };

    const selectNextMatch = () => {
        setSearchFocusIndex(
            searchFocusIndex !== null
                ? (searchFocusIndex + 1) % searchFoundCount
                : 0);
    };

    /////////sortable tree search end//////////////////////////

    ///////////for row height of react sortable tree begin///////////////////

    const customRowHeight = (treeIndex, node, path) =>
        node.subtitle ? 200 : 70;

    ///////////for row height of react sortable tree end////////////////////

    const toggleNodeExpansion = (expanded) => {
        setTreeData((toggleExpandedForAll({ treeData: treeData, expanded })));
    };

    const clickDuplicate = (rowInfo) => {
        console.log(rowInfo);
        const { node, path } = rowInfo;
        let duplicateNode = _.cloneDeep(node);
        let count = 0;

        console.log("prevNOde", node);
        const cast = (item, index) => {
            console.log("count", count);
            console.log("item", index, item);
            if (item.subtitle) {//if exist the subtitle this is product
                item.index = uniqueIndex + count;
                item.subtitle.props.index = uniqueIndex + count
            }
            count++;
        }
        recursively([duplicateNode], cast, 'children');
        console.log("duplicate", duplicateNode);
        console.log("node", node);
        console.log("changed", changedMenuProducts);
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_duplicate_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_duplicate")
        })
            .then(async result => {
                if (result.isConfirmed) {
                    await setTreeData(
                        addNodeUnderParent({
                            treeData: treeData,
                            parentKey: path[path.length - 2], //the "-2" adds the new node as a sibling, if it was "-1" it will add it as a child
                            expandParent: true,
                            getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
                                return number;
                            },
                            newNode: {
                                title: node.title, //the new node's title should be the same as the clicked one
                                subtitle: duplicateNode.subtitle, //the new node's subtitle should be the same as the clicked one
                                children: duplicateNode.children,
                                index: node.index >= 0 ? uniqueIndex : undefined
                            }
                        }).treeData
                    )

                    let tmp = [...changedMenuProducts];
                    const flat = flatten(node, 'children');
                    if (flat.length > 0) {
                        flat.map((data, index) => {
                            if (data.index >= 0) {
                                const pos = changedMenuProducts.findIndex(x => x.index === data.index);
                                tmp = [...tmp, { ...changedMenuProducts[pos], index: uniqueIndex + index }];
                            }
                        })
                    }

                    temper = tmp;   //global
                    setChangedMenuProducts([...tmp]);
                    setUniqueIndex(uniqueIndex + flat.length);
                    console.log("unique", uniqueIndex + flat.length);

                    setMenuSaveDisable(false);
                    dispatch(openSnackBar({ message: t("msg_success_duplicate"), status: 'success' }));
                }
            });
    }

    const clickDelete = (rowInfo) => {
        const { node, path } = rowInfo;

        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_del_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_delete")
        })
            .then(async result => {
                if (result.isConfirmed) {
                    await setTreeData(
                        removeNodeAtPath({
                            treeData: treeData,
                            path: path,   // You can use path from here
                            getNodeKey: ({ node: TreeNode, treeIndex: number }) => {
                                return number;
                            },
                            ignoreCollapsed: true,
                        })
                    )
                    setMenuSaveDisable(false);
                    dispatch(openSnackBar({ message: t("msg_success_delete"), status: 'success' }));

                    console.log(node.index);

                    let tmp = [...changedMenuProducts];
                    const flat = flatten(node, 'children');
                    if (flat.length > 0) {
                        flat.map((data, index) => {
                            if (data.index >= 0) {
                                const pos = tmp.findIndex(x => x.index === data.index);
                                tmp.splice(pos, 1);
                            }
                        })
                    }

                    temper = tmp;   //global
                    setChangedMenuProducts([...tmp]);
                    console.log("delete tmp", tmp);
                }
            });
    }

    const createGroup = (groupName) => {
        setTreeData([{
            title: groupName,
            children: []
        }, ...treeData]);
        setMenuSaveDisable(false);
    }

    const insertProducts = (menuproducts) => {
        let addNode = [];
        let productss = [];

        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_duplicate_product_menu"),
            icon: "warning",
            showDenyButton: true,
            showCancelButton: true,
            denyButtonText: t("swal_no_duplicate"),
            confirmButtonText: t("swal_duplicate")
        })
            .then(async result => {
                if (result.isConfirmed) { //yes
                    menuproducts.map((data, index) => {
                        productss = [...productss, { product: data, product_type: data.product_type, category: data.category, sub_category: data.sub_category, price: [] }]
                    })
                } else if (result.isDenied) { //no
                    menuproducts.map((data, index) => {
                        if (changedMenuProducts.filter(e => e.product._id === data._id).length === 0) {
                            productss = [...productss, { product: data, product_type: data.product_type, category: data.category, sub_category: data.sub_category, price: [] }]
                        }
                    })
                }

                productss.map((data, index) => {
                    productss[index] = { ...productss[index], index: uniqueIndex + index };
                    addNode = [...addNode, {
                        title: data.product.search_field,
                        subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={index} data={data} menu_id={menu_id} index={uniqueIndex + index} isNew={true} />,
                        index: uniqueIndex + index
                    }]
                })

                console.log("insert products", productss);
                console.log("insert unique", uniqueIndex + productss.length);
                setUniqueIndex(uniqueIndex + productss.length);

                temper = [...changedMenuProducts, ...productss];
                setChangedMenuProducts([...changedMenuProducts, ...productss]);
                setTreeData([...addNode, ...treeData]);
                setMenuSaveDisable(false);
            });
    }

    const saveTreeData = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_save_this"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_save")
        })
            .then(async result => {
                if (result.isConfirmed) {
                    const getNodeKey = ({ treeIndex }) => treeIndex;
                    let extendedTreeData = toggleExpandedForAll({ treeData: treeData, expanded: true });
                    const flatteningNestedArray = getFlatDataFromTree({ treeData: extendedTreeData, getNodeKey });

                    console.log("flatte:", flatteningNestedArray);

                    let saveProducts = [];
                    changedMenuProducts.map((data) => {
                        saveProducts = [...saveProducts, { product: data.product._id, price: data.price, product_type: data.product_type._id, category: data.category, sub_category: data.sub_category, index: data.index }]
                    })

                    let res = await dispatch(saveSortableTree({ tree: stringify(flatteningNestedArray), menu_id: menu_id, user_id: userInfo.id, products: JSON.stringify(saveProducts) }))
                    if (res !== false) {
                        dispatch(openSnackBar({ message: t("msg_success_save"), status: 'success' }));
                    }
                    setMenuSaveDisable(true);
                }
            });
    }

    function setMenuSaveDisable(type) {
        setIsSaveDisable(type);
        dispatch(setNoSavedEditedWineMenuPage(type));
    }

    //////////////begin of sort function///////////////////////

    const setSort = (data) => {
        setSortData(data);

        let customized_products = customizeProducts(temper);    //customize the products list for group add some field and change

        customizeGroup(data);   // get the checked group and unchecked group also total group for sort and make the node
        ungroup_final = []; //initialize
        group_final = [];   //initialize
        total_group_final = []; //initialize

        if (total_group.length > 0) {   //customize for tatal sort products
            total_group.map((data, index) => {
                total_group_final = [...total_group_final, { attr: data, asc: total_group_order[index] }]
            })
        }

        customized_products = arrSort(customized_products, [...total_group_final]);     //total sort products

        if (group.length === 0) {    //when not checked the group
            let result = [];

            customized_products.map((data, index) => {
                result = [...result, {
                    title: data.product.search_field,
                    subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={data.index} data={data} menu_id={menu_id} index={data.index} />,
                    index: data.index
                }]
            });

            setTreeData(result);
        } else {
            if (ungroup.length > 0) {   //customize for ungroup sort products
                ungroup.map((data, index) => {
                    ungroup_final = [...ungroup_final, { attr: data, asc: ungroup_order[index] }]
                })
            }
            if (group.length > 0) { //customize for group sort products
                group_order.map((data, index) => {
                    group_final = [...group_final, { attr: 'title', asc: data }]
                })
            }


            let grouped_product = group.length > 0 ? groupArray(customized_products, [...group]) : customized_products; //group by the products

            let customizedTreeData = getNodes(grouped_product); //flat JSON file to tree data with children

            const sortGroup = (item, index) => {    //when title with & so mean sort by id, remove the unnecessary field
                let pos = item.title.indexOf('&');
                if (pos !== -1) {
                    item.title = item.title.substring(pos + 1);
                }
            }
            recursively(customizedTreeData, sortGroup, 'children'); //customize the data to show the react-sortable-tree

            setTreeData(customizedTreeData);
        }

        setMenuSaveDisable(false);
    }

    function customizeProducts(products) {
        let res_products = [];
        if (products.length > 0) {
            products.map((data) => {
                res_products = [
                    ...res_products, {
                        ...data, product: {
                            ...data.product,
                            product_sub_category: data.product_type._id === 0 ? { ...data.product_type.sub[data.category - 1], sort_id: data.product_type.sub[data.category - 1].index + "&" + data.product_type.sub[data.category - 1][`${globalState.language}`] } : { ...data.product_type.sub[data.category], sort_id: data.product_type.sub[data.category].index + "&" + data.product_type.sub[data.category][`${globalState.language}`] },
                            country: { ...data.product.country, sort_id: data.product.country._id + "&" + data.product.country.name[`${globalState.language}`] },
                            region: { ...data.product.region, sort_id: data.product.region._id + "&" + data.product.region.name[`${globalState.language}`] },
                            sub_region: data.product.sub_region ? { ...data.product.sub_region, sort_id: data.product.sub_region._id + "&" + data.product.sub_region.name[`${globalState.language}`] } : { name: { en: "No Sub Region", de: "Keine Unterregion" }, _id: 999999, sort_id: "999999&No Sub Region" },
                            wine_color: data.product.wine_color ? { ...data.product.wine_color, sort_id: data.product.wine_color._id + "&" + data.product.wine_color[`${globalState.language}`] } : { name: { en: "No Wine", de: "Keine Wein" }, _id: 999999, sort_id: "999999&No Wine" },
                            producer_sort: data.product.producer.country + "" + data.product.producer.region + "&" + data.product.producer.name,
                            grape: data.product.grape_variety.length > 0 ? { name: data.product.grape_variety[0].grape[`${globalState.language}`], percentage: data.product.grape_variety[0].percentage } : { name: t("no_group"), percentage: 0 },
                        },
                        product_type: {
                            ...data.product_type,
                            sort_id: data.product_type._id + "&" + data.product_type[`${globalState.language}`]
                        }
                    }
                ]
            })
        }
        return res_products;
    }

    function getNodes(object) {
        return Object
            .entries(object)
            .map(([key, value]) => value && typeof value === 'object'
                ? value?.length > 0 ? { title: key, key, children: customizeValue(value) } : { title: key, key, children: getNodes(value) }
                : { title: key, key, value }
            );
    }

    function customizeValue(products) {
        let result = [];
        // console.log("non group:", ungroup);
        // console.log("notsort:", products);
        products = arrSort(products, [...ungroup_final])
        // console.log("sorted:", products);

        products.map((data, index) => {
            result = [...result, {
                title: data.product.search_field,
                subtitle: <MenuProductItem priceFunc={changePriceOfProduct} key={data.index} data={data} menu_id={menu_id} index={data.index} />,
                index: data.index
            }]
        });
        return result;
    }

    function customizeGroup(data) {
        group = []; //this will be node
        group_order = []; //this will node order
        ungroup = [];   //this will be product only sort
        ungroup_order = [];   //this will be product only sort
        total_group = [];
        total_group_order = [];

        data.map(sort => {
            if (sort.attr.label === t("product-category")) {
                if (sort.order.label !== t("classic")) {
                    total_group = [...total_group, 'product_type.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]    //"asc" = true
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]   //"desc" = false
                    }
                } else {
                    total_group = [...total_group, 'product_type._id'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("product-sub-category")) {
                if (sort.order.label !== t("classic")) {
                    total_group = [...total_group, 'product.product_sub_category.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.product_sub_category.index'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("wine_color")) {
                if (sort.order.label !== t("classic")) {
                    total_group = [...total_group, 'product.wine_color.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.wine_color.index'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("country")) {
                if (sort.order.label !== t("north_to_south")) {
                    total_group = [...total_group, 'product.country.name.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.country.index'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("region")) {
                if (sort.order.label !== t("north_to_south")) {
                    total_group = [...total_group, 'product.region.name.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.region.index'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("sub-region")) {
                if (sort.order.label !== t("north_to_south")) {
                    total_group = [...total_group, 'product.sub_region.name.'+globalState.language];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.sub_region.index'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("producer")) {
                if (sort.order.label !== t("north_to_south")) {
                    total_group = [...total_group, 'product.producer.name'];
                    if (sort.order.label === t("alpha-a-z")) {
                        total_group_order = [...total_group_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        total_group_order = [...total_group_order, false]
                    }
                } else {
                    total_group = [...total_group, 'product.producer_sort'];
                    total_group_order = [...total_group_order, true]
                }
            } else if (sort.attr.label === t("product-name")) {
                total_group = [...total_group, 'product.product_name'];
                if (sort.order.label === t("alpha-a-z")) {
                    total_group_order = [...total_group_order, true]
                } else if (sort.order.label === t("alpha-z-a")) {
                    total_group_order = [...total_group_order, false]
                }
            } else if (sort.attr.label === t("grape-variaty")) {
                total_group = [...total_group, 'product.grape.name'];
                if (sort.order.label === t("alpha-a-z")) {
                    total_group_order = [...total_group_order, true]
                } else if (sort.order.label === t("alpha-z-a")) {
                    total_group_order = [...total_group_order, false]
                }
            }

            if (sort.is_group === true) {
                if (sort.attr.label === t("product-category")) {
                    if (sort.order.label !== t("classic")) {
                        group = [...group, 'product_type.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product_type.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("product-sub-category")) {
                    if (sort.order.label !== t("classic")) {
                        group = [...group, 'product.product_sub_category.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.product_sub_category.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("wine_color")) {
                    if (sort.order.label !== t("classic")) {
                        group = [...group, 'product.wine_color.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.wine_color.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("country")) {
                    if (sort.order.label !== t("north_to_south")) {
                        group = [...group, 'product.country.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.country.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("region")) {
                    if (sort.order.label !== t("north_to_south")) {
                        group = [...group, 'product.region.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.region.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("sub-region")) {
                    if (sort.order.label !== t("north_to_south")) {
                        group = [...group, 'product.sub_region.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.sub_region.sort_id'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("producer")) {
                    if (sort.order.label !== t("north_to_south")) {
                        group = [...group, 'product.producer.name'];
                        if (sort.order.label === t("alpha-a-z")) {
                            group_order = [...group_order, "asc"]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            group_order = [...group_order, "desc"]
                        }
                    } else {
                        group = [...group, 'product.producer_sort'];
                        group_order = [...group_order, "no"]
                    }
                } else if (sort.attr.label === t("grape-variaty")) {
                    group = [...group, 'product.grape.name'];
                    if (sort.order.label === t("alpha-a-z")) {
                        group_order = [...group_order, "asc"]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        group_order = [...group_order, "desc"]
                    }
                }
            } else {
                if (sort.attr.label === t("product-category")) {
                    if (sort.order.label !== t("classic")) {
                        ungroup = [...ungroup, 'product_type.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]    //"asc" = true
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]   //"desc" = false
                        }
                    } else {
                        ungroup = [...ungroup, 'product_type._id'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("product-sub-category")) {
                    if (sort.order.label !== t("classic")) {
                        ungroup = [...ungroup, 'product.product_sub_category.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.product_sub_category.index'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("wine_color")) {
                    if (sort.order.label !== t("classic")) {
                        ungroup = [...ungroup, 'product.wine_color.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.wine_color.index'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("country")) {
                    if (sort.order.label !== t("north_to_south")) {
                        ungroup = [...ungroup, 'product.country.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.country.index'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("region")) {
                    if (sort.order.label !== t("north_to_south")) {
                        ungroup = [...ungroup, 'product.region.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.region.index'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("sub-region")) {
                    if (sort.order.label !== t("north_to_south")) {
                        ungroup = [...ungroup, 'product.sub_region.name.'+globalState.language];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.sub_region.index'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("producer")) {
                    if (sort.order.label !== t("north_to_south")) {
                        ungroup = [...ungroup, 'product.producer.name'];
                        if (sort.order.label === t("alpha-a-z")) {
                            ungroup_order = [...ungroup_order, true]
                        } else if (sort.order.label === t("alpha-z-a")) {
                            ungroup_order = [...ungroup_order, false]
                        }
                    } else {
                        ungroup = [...ungroup, 'product.producer_sort'];
                        ungroup_order = [...ungroup_order, true]
                    }
                } else if (sort.attr.label === t("product-name")) {
                    ungroup = [...ungroup, 'product.product_name'];
                    if (sort.order.label === t("alpha-a-z")) {
                        ungroup_order = [...ungroup_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        ungroup_order = [...ungroup_order, false]
                    }
                } else if (sort.attr.label === t("grape-variaty")) {
                    ungroup = [...ungroup, 'product.grape.name'];
                    if (sort.order.label === t("alpha-a-z")) {
                        ungroup_order = [...ungroup_order, true]
                    } else if (sort.order.label === t("alpha-z-a")) {
                        ungroup_order = [...ungroup_order, false]
                    }
                }
            }
        })
        return { group, group_order, ungroup, ungroup_order };
    }

    //////////////end of sort function///////////////////////

    function findObjectInTree(tree, targetObject, path = []) {
        for (let i = 0; i < tree.length; i++) {
          const node = tree[i];
      
          if (node.index === targetObject) {
            // Found the target object, return it along with the path to it
            return { object: node, path: [...path, i] };
          }
      
          if (typeof node === 'object' && node.children) {
            // Recursively search deeper into the tree
            const result = findObjectInTree(node.children, targetObject, [...path, node.title]);
            if (result) {
              // The target object was found deeper in the tree, add the current node index to the path and return
              return result;
            }
          }
        }
      
        // Target object not found in this branch of the tree
        return null;
    }
      
    const exportCSV = async () => {

        let data_order = []
        const customize = (item, index) => {
            if(Number.isInteger(item.index)){
                data_order = [...data_order, item.index]
                // console.log("here-----------",item.index)
            }
        }
        recursively(treeData, customize, 'children');
        // console.log("order data ----------", data_order)

        let datas = [[
            'product_id', 'producer_name', 'vintage', "article_nr", "aroma",
            "food_pairing", "allergy", "product_name", "product_type", "wine_color",
            "propuct_category", "product_sub_category", "bottle_size", 
            "country_en", "country_de", "country_fr", "country_sk", "country_it", "country_es", "country_pt", "country_nl", "country_native",
            "region_en", "region_de", "region_fr", "region_sk", "region_it", "region_es", "region_pt", "region_nl", "region_native",
            "sub_region_en", "sub_region_de", "sub_region_fr", "sub_region_sk", "sub_region_it", "sub_region_es", "sub_region_pt", "sub_region_nl", "sub_region_native", 
            "grape_variety", "company", 
            "taste", "alc_vol", "barrel_type", "closure_type", "residual_sugar", "wine_acid",
            "image_path", "amount_1", "price_1", "amount_2", "price_2", "amount_3", "price_3", "amount_4", 
            "price_4", "amount_5", "price_5", "amount_6", "price_6", "amount_7", "price_7", "amount_8", 
            "price_8", "amount_9", "price_9", "amount_10", "price_10", "aroma_taste", "official_classification",
            "special_classification", "destillation", "palate", "vessel", "soil_type", "glassware",
            "bottle_shape", "ean", "acidity", "recomended_drinking_temperature_min", "recomended_drinking_temperature_max",
            "path", "description_text", "description_teaser_text", "description_short_text"
        ]];
        if (temper.length > 0) {
            if(data_order.length > 0){
                data_order.map(order => {
                    var data = temper.find(function (element) {
                        return element.index == order;
                    });
                        
                    let { path } = findObjectInTree(treeData, data.index)
                    path.splice(path.length - 1, 1)

                    const { product, price, product_type } = data;
                    const { _id, producer_name, vintage, article_nr, aroma, food_pairing, allergy, product_name, wine_color, category, sub_category, grape_variety, bottle_image,
                        bottle_size, country, region, sub_region, description_text, description_short_text, description_teaser_text, alc_vol, barrel_type, closure_type, wine_acid, company, taste, residual_sugar, 
                        ean, official_classification, special_classification, aroma_taste, palate, vessel, soil_type, acidity, glassware, bottle_shape, distillation, recomended_drinking_temperature } = product;

                    let aroma_show = ""
                    let food_show = ""
                    let allergy_show = ""
                    let grape_show = ""

                    let palate_show = ""
                    let vessel_show = ""
                    let soil_show = ""
                    let aroma_taste_show = ""

                    let path_show = ""

                    if (path.length > 0) {
                        path.map((data, index) => {
                            if (index === aroma.length - 1) {
                                path_show += data;
                            } else {
                                path_show += data + "; "
                            }
                        })
                    }

                    if (aroma.length > 0) {
                        aroma.map((data, index) => {
                            if (index === aroma.length - 1) {
                                aroma_show += data[`${globalState.language}`];
                            } else {
                                aroma_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (food_pairing.length > 0) {
                        food_pairing.map((data, index) => {
                            if (index === food_pairing.length - 1) {
                                food_show += data[`${globalState.language}`];
                            } else {
                                food_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (allergy.length > 0) {
                        allergy.map((data, index) => {
                            if (index === allergy.length - 1) {
                                allergy_show += data[`${globalState.language}`];
                            } else {
                                allergy_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (grape_variety.length > 0) {
                        grape_variety.map((data, index) => {
                            if (index === grape_variety.length - 1) {
                                if (data.percentage === null) {
                                    grape_show += data.grape[`${globalState.language}`];
                                } else {
                                    grape_show += data.percentage + "% " + data.grape[`${globalState.language}`];
                                }
                            } else {
                                if (data.percentage == null) {
                                    grape_show += data.grape[`${globalState.language}`] + "; ";
                                } else {
                                    grape_show += data.percentage + "% " + data.grape[`${globalState.language}`] + "; ";
                                }
                            }
                        })
                    }

                    if (palate.length > 0) {
                        palate.map((data, index) => {
                            if (index === palate.length - 1) {
                                palate_show += data[`${globalState.language}`];
                            } else {
                                palate_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (vessel.length > 0) {
                        vessel.map((data, index) => {
                            if (index === vessel.length - 1) {
                                vessel_show += data[`${globalState.language}`];
                            } else {
                                vessel_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (soil_type.length > 0) {
                        soil_type.map((data, index) => {
                            if (index === soil_type.length - 1) {
                                soil_show += data[`${globalState.language}`];
                            } else {
                                soil_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }
                    if (aroma_taste.length > 0) {
                        aroma_taste.map((data, index) => {
                            if (index === aroma_taste.length - 1) {
                                aroma_taste_show += data[`${globalState.language}`];
                            } else {
                                aroma_taste_show += data[`${globalState.language}`] + "; "
                            }
                        })
                    }

                    let bottlesize_options = ['6.0L', '3.0L', '1.5L', '1.0L', '0.75L', '0.7L', '0.5L', '0.375L', '0.33L', '0.2L'];
                    let amount = [];
                    let amount_price = [];
                    if (price.length > 0) {
                        price.map((data, index) => {
                            amount = [...amount, bottlesize_options[data.bottle_size]];
                            amount_price = [...amount_price, data.price + data.price_unit]
                        })
                    }

                    // someText = someText.replace(/(\r\n|\n|\r)/gm, "");
                    let description_text_show, description_teaser_text_show, description_short_text_show;

                    if(description_text){
                        description_text_show = description_text.replace(/(\r\n|\n|\r)/gm, "");
                    }else{
                        description_text_show = ""
                    }

                    if(description_teaser_text){
                        description_teaser_text_show = description_teaser_text.replace(/(\r\n|\n|\r)/gm, "");
                    }else{
                        description_teaser_text_show = ""
                    }

                    if(description_short_text){
                        description_short_text_show = description_short_text.replace(/(\r\n|\n|\r)/gm, "");
                    }else{
                        description_short_text_show = ""
                    }
                    // description_show = description_show.replace(/,/gm, '  ');
                    // console.log(description_show);


                    datas = [...datas, {
                        product_id: _id,
                        producer_name: producer_name,
                        vintage: vintage ? vintage : "   ",
                        article_nr: article_nr ? article_nr : "   ",
                        aroma: aroma.length > 0 ? aroma_show : "   ",
                        food_pairing: food_pairing.length > 0 ? food_show : "   ",
                        allergy: allergy.length > 0 ? allergy_show : "   ",
                        product_name: product_name ? product_name : "   ",
                        product_type: product_type[`${globalState.language}`],
                        wine_color: wine_color ? wine_color[`${globalState.language}`] : "   ",
                        propuct_category: category ? (product_type._id === 0 ? (product_type.sub[category - 1][`${globalState.language}`] ? product_type.sub[category - 1][`${globalState.language}`] : "   ") : (product_type.sub[category][`${globalState.language}`]) ? product_type.sub[category][`${globalState.language}`] : "   ") : "   ",
                        product_sub_category: sub_category ? (product_type._id === 0 ? (product_type.sub[category - 1].sub[sub_category] ? product_type.sub[category - 1].sub[sub_category] : "   ") : (product_type.sub[category].sub[sub_category]) ? product_type.sub[category].sub[sub_category] : "   ") : "   ",
                        bottle_size: bottle_size.bottle_size + " " + bottle_size.unit,
                        country_en: country.name.en,
                        country_de: country.name.de,
                        country_fr: country.name.fr,
                        country_sk: country.name.sk,
                        country_it: country.name.it,
                        country_es: country.name.es,
                        country_pt: country.name.pt,
                        country_nl: country.name.nl,
                        country_native: country.name.native,
                        region_en: region.name.en,
                        region_de: region.name.de,
                        region_fr: region.name.fr,
                        region_sk: region.name.sk,
                        region_it: region.name.it,
                        region_es: region.name.es,
                        region_pt: region.name.pt,
                        region_nl: region.name.nl,
                        region_native: region.name.native,
                        sub_region_en: sub_region ? sub_region.name.en : "   ",
                        sub_region_de: sub_region ? sub_region.name.de : "   ",
                        sub_region_fr: sub_region ? sub_region.name.fr : "   ",
                        sub_region_sk: sub_region ? sub_region.name.sk : "   ",
                        sub_region_it: sub_region ? sub_region.name.it : "   ",
                        sub_region_es: sub_region ? sub_region.name.es : "   ",
                        sub_region_pt: sub_region ? sub_region.name.pt : "   ",
                        sub_region_nl: sub_region ? sub_region.name.nl : "   ",
                        sub_region_native: sub_region ? sub_region.name.native : "   ",
                        grape_variety: grape_variety.length > 0 ? grape_show : "   ",
                        company: company ? company.name : "   ",
                        taste: taste ? product_type.sub[category - 1].taste[taste] : "   ",
                        alc_vol: alc_vol ? `\"${alc_vol}\"` : "   ",//alc_vol.replace(/\"/g, "\"\"")
                        barrel_type: barrel_type ? `\"${barrel_type}\"` : "   ",//barrel_type.replace(/\"/g, "\"\"")
                        closure_type: closure_type ? closure_type[`${globalState.language}`] : "   ",
                        residual_sugar: residual_sugar ? `\"${residual_sugar}\"` : "   ",//residual_sugar.replace(/\"/g, "\"\"")
                        wine_acid: wine_acid ? `\"${wine_acid}\"` : "   ",//wine_acid.replace(/\"/g, "\"\"")
                        image_path: bottle_image.changed_name ? "/image/" + bottle_image.changed_name.toString() : "   ",
                        amount_1: amount[0] ? amount[0] : "   " , price_1: amount_price[0] ? `\"${amount_price[0]}\"` : "   ",//amount_price[0]
                        amount_2: amount[1] ? amount[1] : "   " , price_2: amount_price[1] ? `\"${amount_price[1]}\"` : "   ",//amount_price[1]
                        amount_3: amount[2] ? amount[2] : "   " , price_3: amount_price[2] ? `\"${amount_price[2]}\"` : "   ",//amount_price[2]
                        amount_4: amount[3] ? amount[3] : "   " , price_4: amount_price[3] ? `\"${amount_price[3]}\"` : "   ",//amount_price[3]
                        amount_5: amount[4] ? amount[4] : "   " , price_5: amount_price[4] ? `\"${amount_price[4]}\"` : "   ",//amount_price[4]
                        amount_6: amount[5] ? amount[5] : "   " , price_6: amount_price[5] ? `\"${amount_price[5]}\"` : "   ",//amount_price[5]
                        amount_7: amount[6] ? amount[6] : "   " , price_7: amount_price[6] ? `\"${amount_price[6]}\"` : "   ",//amount_price[6]
                        amount_8: amount[7] ? amount[7] : "   " , price_8: amount_price[7] ? `\"${amount_price[7]}\"` : "   ",//amount_price[7]
                        amount_9: amount[8] ? amount[8] : "   " , price_9: amount_price[8] ? `\"${amount_price[8]}\"` : "   ",//amount_price[8]
                        amount_10: amount[9] ? amount[9] : "   " , price_10: amount_price[9] ? `\"${amount_price[9]}\"` : "   ",//amount_price[9]
                        
                        aroma_taste: aroma_taste.length > 0 ? aroma_taste_show : "   ",
                        official_classification: official_classification ? official_classification[`${globalState.language}`] : "   ",
                        special_classification: special_classification ? special_classification[`${globalState.language}`] : "   ",
                        destillation: distillation ? distillation[`${globalState.language}`] : "   ",
                        palate: palate.length > 0 ? palate_show : "   ",
                        vessel: vessel.length > 0 ? vessel_show : "   ",
                        soil_type: soil_type.length > 0 ? soil_show : "   ",
                        glassware: glassware ? glassware[`${globalState.language}`] : "   ",
                        bottle_shape: bottle_shape ? bottle_shape[`${globalState.language}`] : "   ",
                        ean: ean ? ean.toString() : "   ",
                        acidity: acidity ? `\"${acidity}\"` : "   ",//acidity.replace(/\"/g, "\"\"")
                        recomended_drinking_temperature_min: recomended_drinking_temperature ? recomended_drinking_temperature[0] : "   ", 
                        recomended_drinking_temperature_max: recomended_drinking_temperature ? recomended_drinking_temperature[1] : "   ", 
                        path: path.length > 0 ? path_show : "   ",
                        description_teaser_text: description_teaser_text ? `\"${description_teaser_text_show}\"`: "   ",//description_text.replace(/\"/g, "\"\"")
                        description_short_text: description_short_text ? `\"${description_short_text_show}\"`: "   ",//description_text.replace(/\"/g, "\"\"")
                        description_text: description_text ? `\"${description_text_show}\"`: "   ",//description_text.replace(/\"/g, "\"\"")
                    }]
                
                })
            }
        }

        let tabdata = tab_stringify(datas);
        tabdata = tabdata.replace('image_path', '@images')
        tabdata = tabdata.replace(/undefined	/g, '         	')
        // console.log(tabdata);

        const buffer = Buffer.from(tabdata, 'utf16le')

        // download txt 
        var blob = new Blob([buffer]);
        FileSaver.saveAs(blob, menu_name);
        
        // download image
        let res = await dispatch(downloadImage(menu_id))
        if(res != false){
            downloadImageFile(res.name, menu_name);
        }else{
            dispatch(openSnackBar({ message: t("image download failed"), status: 'error' }));
        }
    }

    const downloadImageFile = (name, menu_name) => {
		fetch( `${API_BASE}/public/download/`+name)
			.then(response => {
				response.blob().then(blob => {
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement('a');
					a.href = url;
					a.download = menu_name + "-" + name;
					a.click();
				});
				//window.location.href = response.url;
		});
	}

    return (
        // <div>
        //     <div className="flex justify-between mx-8 py-4">
        //         <div className="flex gap-4">
        //             <AddProductsModal addProducts={insertProducts} />
        //             <CreateGroupModal addGroup={createGroup} />
        //         </div>
        //         <div className="flex gap-4">
        //             {
        //                 userInfo?.role == 1 && 
        //                 <div>
        //                     <Button onClick={() => exportCSV()} outline={true} className="bg-sitebg-200" >
        //                         <BiExport className="mr-2 h-6 w-6 text-sitebg-50" />
        //                         {t("export_csv")}
        //                     </Button>
        //                 </div>
        //             }
        //             {/* <div>
        //                 <Button onClick={() => printList()} outline={true} className="bg-sitebg-200" >
        //                     <HiOutlinePrinter className="mr-2 h-6 w-6 text-sitebg-50" />
        //                     {t("print_list")}
        //                 </Button>
        //             </div> */}
        //             <div>
        //                 <Button onClick={() => saveTreeData()} outline={true} className="bg-sitebg-200" disabled={isSaveDisable} >
        //                     <FiSave className="mr-2 h-6 w-6 text-sitebg-300" />
        //                     {t("save_changes")}
        //                 </Button>
        //             </div>
        //         </div>
        //     </div>

        //     <div className="flex justify-between mx-8 pb-2">
        //         <SortModal setData={setSort} />
        //         <div className="flex gap-4">
        //             <div className="flex">
        //                 <div className="m-2 mr-4 block">
        //                     {t("search")}
        //                 </div>
        //                 <TextInput
        //                     type="search"
        //                     placeholder="Search name"
        //                     value={searchString}
        //                     icon={HiOutlineSearch}
        //                     onChange={(e) => handleSearchOnChange(e)}
        //                     color="info"
        //                 />
        //             </div>
        //             <div>
        //                 <Button onClick={() => selectPrevMatch()} >
        //                     <HiOutlineArrowLeft className="mr-2 h-5 w-5" />
        //                     {t("previous")}
        //                 </Button>
        //             </div>
        //             <div>
        //                 <Button onClick={() => selectNextMatch()} >
        //                     {t("next")}
        //                     <HiOutlineArrowRight className="ml-2 h-5 w-5" />
        //                 </Button>
        //             </div>
        //             <div className="m-2 block">
        //                 {searchFocusIndex} / {searchFoundCount}
        //             </div>
        //         </div>
        //         <div className="flex gap-4">
        //             <div className="flex items-center">
        //                 <div onClick={() => toggleNodeExpansion(true)} className="flex justify-center items-center px-4 cursor-pointer rounded-lg">
        //                     <BsArrowsAngleExpand className="mr-2 h-6 w-6 text-sitebg-50 " />
        //                     <ul>{t("expand_all")}</ul>
        //                 </div>
        //             </div>
        //             <div className="flex items-center">
        //                 <div onClick={() => toggleNodeExpansion(false)} className="flex justify-center items-center px-4 cursor-pointer rounded-lg">
        //                     <BsArrowsAngleContract className="mr-2 h-6 w-6 text-sitebg-50" />
        //                     <ul>{t("collapse_all")}</ul>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>

        //     <div className="p-4">
        //         <SortableStyle>
        //             <SortableTree
        //                 // theme={FileExplorerTheme}
        //                 treeData={treeData}
        //                 onChange={data => handleTreeOnChange(data)}
        //                 onMoveNode={({ node, treeIndex, path }) =>
        //                     global.console.debug(
        //                         "node:",
        //                         node,
        //                         "treeIndex:",
        //                         treeIndex,
        //                         "path:",
        //                         path
        //                     )
        //                 }
        //                 maxDepth={maxDepth}                     //depth of tree
        //                 onlyExpandSearchedNodes={true}
        //                 searchMethod={customSearchMethod}       //for search regex
        //                 searchQuery={searchString}              //search string
        //                 searchFocusOffset={searchFocusIndex}    //search focus node
        //                 canDrag={({ node }) => !node.noDragging}
        //                 canDrop={({ nextParent }) => !nextParent || !nextParent.noChildren}
        //                 searchFinishCallback={(matches) => {
        //                     setSearchFoundCount(matches.length);
        //                     setSearchFocusIndex(matches.length > 0 ? searchFocusIndex % matches.length : 0);
        //                 }}
        //                 isVirtualized={true}
        //                 // style={{ borderRadius: "50px", width: "100%" }}
        //                 rowHeight={customRowHeight}
        //                 generateNodeProps={(rowInfo) => {
        //                     const { node, path } = rowInfo;
        //                     return {
        //                         title: (
        //                             <TextInput
        //                                 type="search"
        //                                 sizing="md"
        //                                 required={true}
        //                                 icon={FiEdit3}
        //                                 value={node.title}
        //                                 className={`${node.subtitle ? "hidden" : "none"} `}
        //                                 onChange={event => {
        //                                     const title = event.target.value;

        //                                     setTreeData(changeNodeAtPath({
        //                                         treeData: treeData,
        //                                         path,
        //                                         getNodeKey: ({ treeIndex }) => treeIndex,
        //                                         newNode: { ...node, title },
        //                                     }));
        //                                 }}
        //                             />
        //                         ),
        //                         buttons: [
        //                             <Tooltip
        //                                 style="light"
        //                                 content={
        //                                     <div >
        //                                         <div onClick={() => clickDuplicate(rowInfo)} className="flex text-gray-600 p-1 cursor-pointer hover:bg-gray-100">
        //                                             <HiOutlineDuplicate className="h-6 w-6 mr-2 text-gray-600" />
        //                                             {t("duplicate")}
        //                                         </div>
        //                                         <div onClick={() => clickDelete(rowInfo)} className="flex text-red-500 p-1 cursor-pointer hover:bg-gray-100">
        //                                             <HiOutlineTrash className="h-6 w-6 mr-2 text-red-500" />
        //                                             {t("delete")}
        //                                         </div>
        //                                     </div>
        //                                 }
        //                                 placement="left"
        //                                 arrow={false}
        //                                 trigger="hover"
        //                             >
        //                                 <HiDotsHorizontal className="w-6 h-6 text-sitetx-200" />
        //                             </Tooltip>
        //                         ],
        //                         // style: { borderRadius: `10px`, maxWidth: "1100px" }
        //                     };
        //                 }}
        //             />
        //         </SortableStyle>
        //     </div>
        // </div>
        <>
            {
                (downloadImageState || saveSortableTreeState) && <Loading />
            }
            <div className="sortable-layout" style={{minWidth: "1200px"}}>
                <div className="sortable-toolbar" >
                    <div className="header">
                        {t("menu_edit")}
                    </div>
                    <div className="actions">
                        <TextInput className="item"
                            type="search"
                            placeholder={t("what_are_looking")}
                            value={searchString}
                            icon={HiOutlineSearch}
                            onChange={(e) => handleSearchOnChange(e)}
                            size='sm'
                        />
                        <div className="item">
                            <div className="btn-prv" style={{ boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)' }} onClick={() => selectPrevMatch()}>
                                <svg className="w-4 h-4 mt-1" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M16.25,23.25,5.53,12.53a.749.749,0,0,1,0-1.06L16.25.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /></svg>
                            </div>
                        </div>
                        <div className="item">
                            <div className="btn-prv" style={{ boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)' }} onClick={() => selectNextMatch()}>
                                <svg viewBox="0 0 24 24" className="w-4 h-4 mt-1" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M5.5.75,16.22,11.47a.749.749,0,0,1,0,1.06L5.5,23.25" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /></svg>
                            </div>
                        </div>
                        <SortModal setData={setSort} />
                        {/* <div className="m-2 block">
                            {searchFocusIndex} / {searchFoundCount}
                        </div> */}
                    </div>
                </div>
                <div className="sortable-scroll-container">
                    <div className="sortable-container bg-white mt-3">
                        <div className="p-4 border-b-2 sortable-navbar border-gray-200">
                            <div className="add-group">
                                <AddProductsModal addProducts={insertProducts} />
                                <CreateGroupModal addGroup={createGroup} />
                            </div>
                            <div className="tools">
                                <div className="collapse-expand">
                                    {/* <div onClick={() => toggleNodeExpansion(false)} className="flex justify-center items-center px-4 cursor-pointer rounded-lg border-2 border-gray-200 bg-white ">
                                    <BsArrowsAngleContract className="mr-2 h-6 w-6 text-sitebg-50" />
                                    <ul>{t("collapse_all")}</ul>
                                </div> */}

                                    {/* <div onClick={() => toggleNodeExpansion(true)} className="flex justify-center items-center px-4 cursor-pointer rounded-lg">
                                        <BsArrowsAngleExpand className="mr-2 h-6 w-6 text-sitebg-50 " />
                                        <ul>{t("expand_all")}</ul>
                                    </div> */}
                                    <Button onClick={() => toggleNodeExpansion(true)} color="red" outline={true} className=" border-2 border-gray-200 bg-white mr-2" >
                                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-5  w-5" stroke-width="1.5">
                                            <path d="M9.75 14.248L0.75 23.248" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M23.25 7.498L23.25 0.748 16.5 0.748" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M0.75 16.498L0.75 23.248 7.5 23.248" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M23.25 0.748L14.25 9.748" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /></svg>

                                        <div className="">
                                            {t("expand_all")}
                                        </div>
                                    </Button>
                                    <Button onClick={() => toggleNodeExpansion(false)} color="red" outline={true} className=" border-2 border-gray-200 bg-white" >
                                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5" className="h-5  w-5 mr-2">
                                            <path d="M23.25 0.748L14.25 9.748" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.75 20.998L9.75 14.248 3 14.248" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M14.25 2.998L14.25 9.748 21 9.748" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.75 14.248L0.75 23.248" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /></svg>

                                        <div className="">
                                            {t("collapse_all")}
                                        </div>
                                    </Button>
                                </div>
                                <div className="export-save">
                                    <div>{
                                        userInfo?.role === 0 &&
                                        <div>
                                            <Button onClick={() => exportCSV()} color="red" outline={true} className=" border-2 border-gray-200 bg-white mr-2" >
                                                {/* <BiExport className="mr-2 h-6 w-6 text-sitebg-50" /> */}
                                                <svg className="h-5  w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 14.25V20.25" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 20.25L15 18" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M17.25 20.25L19.5 18" /><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M10.226 4.557C10.2602 4.83153 10.2356 5.11018 10.1539 5.37449C10.0722 5.63879 9.9352 5.88269 9.75202 6.09C9.56106 6.2974 9.32917 6.46294 9.07099 6.57617C8.8128 6.68941 8.53395 6.74787 8.25202 6.74787C7.9701 6.74787 7.69124 6.68941 7.43306 6.57617C7.17488 6.46294 6.94299 6.2974 6.75202 6.09C6.56884 5.88269 6.43185 5.63879 6.35013 5.37449C6.26841 5.11018 6.24383 4.83153 6.27802 4.557L6.75002 0.75H9.75002L10.226 4.557Z" /><path stroke="#000000" d="M8.25 13.875C8.04289 13.875 7.875 13.7071 7.875 13.5C7.875 13.2929 8.04289 13.125 8.25 13.125" /><path stroke="#000000" d="M8.25 13.875C8.45711 13.875 8.625 13.7071 8.625 13.5C8.625 13.2929 8.45711 13.125 8.25 13.125" /><path stroke="#000000" d="M8.25 17.625C8.04289 17.625 7.875 17.4571 7.875 17.25C7.875 17.0429 8.04289 16.875 8.25 16.875" /><path stroke="#000000" d="M8.25 17.625C8.45711 17.625 8.625 17.4571 8.625 17.25C8.625 17.0429 8.45711 16.875 8.25 16.875" /><g><path stroke="#000000" d="M8.25 10.125C8.04289 10.125 7.875 9.95711 7.875 9.75C7.875 9.54289 8.04289 9.375 8.25 9.375" /><path stroke="#000000" d="M8.25 10.125C8.45711 10.125 8.625 9.95711 8.625 9.75C8.625 9.54289 8.45711 9.375 8.25 9.375" /></g><path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" d="M7.5 20.25H2.25C1.85218 20.25 1.47064 20.092 1.18934 19.8107C0.908035 19.5294 0.75 19.1478 0.75 18.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.879C13.2765 0.750085 13.6578 0.907982 13.939 1.189L16.811 4.061C17.092 4.3422 17.2499 4.72345 17.25 5.121V8.25" /></svg>
                                                {t("export_csv")}
                                            </Button>
                                        </div>
                                    }</div>
                                    <Button onClick={() => saveTreeData()} color="red" outline={true} className=" border-2 border-gray-200 bg-white mr-2" disabled={isSaveDisable} >
                                        {/* <FiSave className="mr-2 h-6 w-6 text-sitebg-300" /> */}
                                        <svg className="h-5  w-5 mr-2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M21.75,23.25H2.25a1.5,1.5,0,0,1-1.5-1.5V7.243a3,3,0,0,1,.879-2.121L5.121,1.629A3,3,0,0,1,7.243.75H21.75a1.5,1.5,0,0,1,1.5,1.5v19.5A1.5,1.5,0,0,1,21.75,23.25Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.25.75v6a1.5,1.5,0,0,0,1.5,1.5h7.5a1.5,1.5,0,0,0,1.5-1.5v-6" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.75 3.75L15.75 5.25" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /><path d="M17.25,12.75H6.75a1.5,1.5,0,0,0-1.5,1.5v9h13.5v-9A1.5,1.5,0,0,0,17.25,12.75Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.25 15.75L12.75 15.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.25 18.75L15.75 18.75" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" /></svg>
                                        {t("save_changes")}
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="p-4 sortable-content">
                        {/* <SortableStyle>
                                <SortableTree
                                    // theme={FileExplorerTheme}
                                    treeData={treeData}
                                    onChange={data => handleTreeOnChange(data)}
                                    onMoveNode={({ node, treeIndex, path }) =>
                                        global.console.debug(
                                            "node:",
                                            node,
                                            "treeIndex:",
                                            treeIndex,
                                            "path:",
                                            path
                                        )
                                    }
                                    maxDepth={maxDepth}                     //depth of tree
                                    onlyExpandSearchedNodes={true}
                                    searchMethod={customSearchMethod}       //for search regex
                                    searchQuery={searchString}              //search string
                                    searchFocusOffset={searchFocusIndex}    //search focus node
                                    canDrag={({ node }) => !node.noDragging}
                                    canDrop={({ nextParent }) => !nextParent || !nextParent.noChildren}
                                    searchFinishCallback={(matches) => {
                                        setSearchFoundCount(matches.length);
                                        setSearchFocusIndex(matches.length > 0 ? searchFocusIndex % matches.length : 0);
                                    }}
                                    isVirtualized={true}
                                    // style={{ borderRadius: "50px", width: "100%" }}
                                    rowHeight={customRowHeight}
                                    generateNodeProps={(rowInfo) => {
                                        const { node, path } = rowInfo;
                                        return 
                                    }}
                                />
                            </SortableStyle> */}
                            <SortableStyle>
                                <SortableTree
                                    // theme={FileExplorerTheme}
                                    treeData={treeData}
                                    onChange={data => handleTreeOnChange(data)}
                                    onMoveNode={({ node, treeIndex, path }) =>
                                        global.console.debug(
                                            "node:",
                                            node,
                                            "treeIndex:",
                                            treeIndex,
                                            "path:",
                                            path
                                        )
                                    }
                                    maxDepth={maxDepth}                     //depth of tree
                                    onlyExpandSearchedNodes={true}
                                    searchMethod={customSearchMethod}       //for search regex
                                    searchQuery={searchString}              //search string
                                    searchFocusOffset={searchFocusIndex}    //search focus node
                                    canDrag={({ node }) => !node.noDragging}
                                    canDrop={({ nextParent }) => !nextParent || !nextParent.noChildren}
                                    searchFinishCallback={(matches) => {
                                        setSearchFoundCount(matches.length);
                                        setSearchFocusIndex(matches.length > 0 ? searchFocusIndex % matches.length : 0);
                                    }}
                                    isVirtualized={true}
                                    // style={{ borderRadius: "50px", width: "100%" }}
                                    rowHeight={customRowHeight}
                                    generateNodeProps={(rowInfo) => {
                                        const { node, path } = rowInfo;
                                        return {
                                            title: (
                                                <TextInput
                                                    type="search"
                                                    sizing="md"
                                                    required={true}
                                                    icon={FiEdit3}
                                                    value={node.title}
                                                    className={`${node.subtitle ? "hidden" : "none"} `}
                                                    onChange={event => {
                                                        const title = event.target.value;

                                                        setTreeData(changeNodeAtPath({
                                                            treeData: treeData,
                                                            path,
                                                            getNodeKey: ({ treeIndex }) => treeIndex,
                                                            newNode: { ...node, title },
                                                        }));
                                                    }}
                                                />
                                            ),
                                            buttons: [
                                                <Tooltip
                                                    style="light"
                                                    content={
                                                        <div >
                                                            <div onClick={() => clickDuplicate(rowInfo)} className="flex text-gray-600 p-1 cursor-pointer hover:bg-gray-100">
                                                                <HiOutlineDuplicate className="h-6 w-6 mr-2 text-gray-600" />
                                                                {t("duplicate")}
                                                            </div>
                                                            <div onClick={() => clickDelete(rowInfo)} className="flex text-red-500 p-1 cursor-pointer hover:bg-gray-100">
                                                                <HiOutlineTrash className="h-6 w-6 mr-2 text-red-500" />
                                                                {t("delete")}
                                                            </div>
                                                        </div>
                                                    }
                                                    placement="left"
                                                    arrow={false}
                                                    trigger="hover"
                                                >
                                                    <HiDotsHorizontal className="w-6 h-6 text-sitetx-200" />
                                                </Tooltip>
                                            ],
                                            // style: { borderRadius: `10px`, maxWidth: "1100px" }
                                        };
                                    }}
                                />
                            </SortableStyle>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Sortable;
